// extracted by mini-css-extract-plugin
export default {"description":"style_description__yrGBX","fade-in":"style_fade-in__4wMkN","top":"style_top__8S3S3","image":"style_image__LHNjp"};